import { Descriptions } from 'antd';
import { deviceCategoryTranslated } from 'components/Form/meter_details/constants';
import { FormattedMessage, IntlShape } from 'react-intl';
import { MeterDetailOther } from '@enmon/commons/lib/enmon';
import { MeterDetails as messages } from './messages';

export const getOtherDetailDescriptions = (details: MeterDetailOther | undefined, intl: IntlShape) => {
  const { deviceCategory } = details ?? {};

  return (
    <Descriptions.Item label={<FormattedMessage {...messages.equipmentCategory} />}>
      {deviceCategory && intl.formatMessage(deviceCategoryTranslated[deviceCategory])}
    </Descriptions.Item>
  );
};
